import React, { forwardRef, useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { useMediaQuery } from "react-responsive";
import {
  useNavigate,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import { editPropertyDetails } from "../../../homepurchase.service";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { Toast } from "primereact/toast";
import { Loading } from "app/components";
import { Calendar } from "primereact/calendar";
import { formatDate } from "app/utils/utility.service";
import { NumericFormat } from "react-number-format";
import { confirmDialog } from "primereact/confirmdialog";
import { InputNumber } from "primereact/inputnumber";

const PropertyInformation = ({
  handleInputChange,
  handleInputChanges,
  handleDateChange,
  handleInputChangeRent,
  values,
  purchaseDate,
  appreciation,
  setValues
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [invalidYear, setInvalidYear] = useState(false);
   const [invalidRentYear, setInvalidRentYear] = useState(false);
  const { data, setData } = useOutletContext(); // Access Parent's state
  const toast = useRef();
  const minValue = 1;
  const maxValue = 99.99;

  const countries = [
    { name: "Australia", code: "AU" },
    { name: "Brazil", code: "BR" },
    { name: "China", code: "CN" },
    { name: "Egypt", code: "EG" },
    { name: "France", code: "FR" },
    { name: "Germany", code: "DE" },
    { name: "India", code: "IN" },
    { name: "Japan", code: "JP" },
    { name: "Spain", code: "ES" },
    { name: "United States", code: "US" },
  ];
  const [searchParams] = useSearchParams();
  const index = searchParams.get("index");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const currentYear = new Date().getFullYear();
  const startYear = 1900;

  const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => ({
    label: `${startYear + i}`,
    value: String(startYear + i),
  }));
  
  const showSuccess = (message) => {
    toast.current.show(SuccessToastConfig(message));
  };
  const showError = (message) => {
    toast.current.show(ErrorToastConfig(message ? message : "Error"));
  };
  const handleYearChange = (e) => {
    const { name, value } = e.target;
 
    if (name == 'yearBuilt' && (value === null || value === undefined)) {
      setValues({
        ...values,
        yearBuilt: null,
      });
      setInvalidYear(true);
    } else {
      // ✅ ensure integer
     // val = Math.trunc(val);

      // ✅ enforce min/max year range for yearBuilt
      if (name == 'yearBuilt' && (value < 1900 || value > currentYear)) setInvalidYear(true);
      else setInvalidYear(false);

      // Handle rentStartDate validation (new logic)
      if (name == 'rentStartDate') {
        // If rent field value is present, rental year is mandatory
        if (values.rent && values.rent > 0) {
          if (value === null || value === undefined || value === '') {
            setInvalidRentYear(true);
          } else {
            // Rent year can't be before purchase year and can't be greater than current year
            const purchaseYear = values.purchaseDate ? new Date(values.purchaseDate).getFullYear() : null;
            if (purchaseYear && (value < purchaseYear)) {
              setInvalidRentYear(true);
            } else {
              setInvalidRentYear(false);
            }
          }
        } else {
          setInvalidRentYear(false);
        }
      }

      setValues({
        ...values,
        [name]: value? String(value):"",
      });
    }
  };
  const validateInput = () => {
    if (
      !values.addressOne ||
      !values.city ||
      !values.state ||
      !values.country ||
      !values.zipcode ||
      !values.yearBuilt ||
      !values.typeOfBuilding ||
      !values.description ||
      !values.occupancy ||
      !values.category
    ) {
      return false;
    }

    if (isNaN(values.zipcode)) {
      return false;
    }

    // Validate rental year if rental income is provided
    if (values.rent && values.rent > 0) {
      if (!values.rentStartDate || invalidRentYear) {
        return false;
      }
    }

    return true;
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const confirmAction = (message, header = "Confirm") => {
    return new Promise((resolve) => {
      confirmDialog({
        message: message,
        header: "Confirmation",
        acceptClassName: "p-button-raised p-button-lg",
        rejectClassName: "p-button-raised p-button-warning p-button-lg",
        accept: () => {
          //changeProjectedValue = true;
          resolve(true);
        },
        reject: () => {
          // changeProjectedValue = false;

          resolve(false);
        },
      });
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    if (!validateInput() || invalidYear || invalidRentYear) {
      return false;
    }

    let changeProjectedValue = false;

    if (
      appreciation !== values.appreciation ||
      purchaseDate !== values.purchaseDate
    ) {
      changeProjectedValue = await confirmAction(
        "Editing this value will cause a change in value in Accounts Section. Do you want to proceed?"
      );
    }
    values.valuesModified = changeProjectedValue;
    const details = await editPropertyDetails(values, values.id);
    if (details) {
      showSuccess("Record updated successfully");
      // insert settings value
      setIsLoading(false);
      /*  setTimeout(() => {
        navigate("/home-purchase/portfolio/realestate");
      }, 1000);*/
      setData({
        purchasePrice: details?.purchasePrice,
        addressOne: details?.addressOne,
        appreciation: details?.appreciation,
        dataPresent: true,
      });
    } else {
      showError("Error");
    }
  };
  const renderFooter = () => {
    return (
      <div className="grid">
        <div
          className={`${
            isDesktopOrLaptop ? "col-8" : "col-12 text-align-center"
          }`}
        >
          <Button
            type="button"
            label="Cancel"
            className="p-button-raised p-button-lg mr-4"
            onClick={() => navigate("/home-purchase/portfolio/realestate")}
          />
          <Button
            type="submit"
            label="Save"
            className={`p-button-raised p-button-warning p-button-lg  ${
              isDesktopOrLaptop ? "" : "ml-4"
            }`}
            onClick={handleSubmit}
          />
        </div>
      </div>
    );
  };
  return (
    <Panel className={`mb-2 OwnHouse `}>
      {isLoading && <Loading />}
      <Toast ref={toast} className="ToastMessage" />
      <div className="grid mr-6">
        <div className="col-4"></div>
        <div className="col-6 mb-4">
          <span style={{ color: "#6c757d" }}>
            <b>{values?.addressOne}</b>
          </span>
        </div>
      </div>
      <div className={`mb-2 align-text`}>
        <div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Property ID</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="propertyId"
                    disabled={true}
                    value={index}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Purchase Date</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <Calendar
                    id="buttondisplay"
                    name="purchaseDate"
                    value={
                      values?.purchaseDate
                        ? new Date(formatDate(values?.purchaseDate))
                        : new Date(formatDate(values?.createdAt))
                    }
                    showIcon
                    dateFormat="mm/dd/yy"
                    onChange={handleDateChange}
                  />
                </div>
              </div>

              <div className="text-align-left">
                {formSubmitted && !values?.createdAt && (
                  <small className="p-error">Please enter purchase date</small>
                )}
              </div>
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Address 1</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    id="addressOne"
                    autoFocus
                    className="vw-inputtext-with-border"
                    name="addressOne" // Set name to identify the property
                    value={values?.addressOne} // Bind value to specific property
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {formSubmitted && !values?.addressOne && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter address1</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Address 2</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    name="addressTwo"
                    id="addressTwo"
                    value={values?.addressTwo}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>City</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="city"
                    onChange={handleInputChange}
                    value={values?.city}
                  />
                </div>
              </div>

              {formSubmitted && !values?.city && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter city</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>State</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="state"
                    onChange={handleInputChange}
                    value={values?.state}
                  />
                </div>
              </div>

              {formSubmitted && !values?.state && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter state</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Country</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <span className="p-float-label">
                    <Dropdown
                      className="vw-dropdown zipcode-dropdown"
                      value={values?.country}
                      options={countries}
                      required={true}
                      name="country"
                      onChange={handleInputChange}
                      optionLabel="name"
                      optionValue="name"
                      style={{
                        border: "1px solid #ced4da", // Customize the border color and width
                        borderRadius: "3px", // Optional: round the corners
                        padding: "5px", // Optional: add padding for spacing
                      }}
                      // placeholder="Select a Country"
                    />
                  </span>
                </div>
              </div>
              <div className="text-align-left">
                {formSubmitted && !values?.country && (
                  <small className="p-error">Please enter country</small>
                )}
              </div>
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>ZIP Code</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="zipcode"
                    onChange={handleInputChange}
                    value={values?.zipcode}
                  />
                </div>
              </div>

              {formSubmitted && !values?.zipcode && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter ZIP CODE</small>
                </div>
              )}
              {formSubmitted && isNaN(values?.zipcode) && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">
                    Zip code must be in numeric format
                  </small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Year built</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                    <InputNumber
                        className="vw-inputnumber-with-border"
                        useGrouping={false}
                        maxFractionDigits={0}
                        placeholder="YYYY"
                        name="yearBuilt"
                        onValueChange={handleYearChange}
                        value={values?.yearBuilt}
                      />
                </div>
              </div>

              {formSubmitted && !values?.yearBuilt && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter year built</small>
                </div>
              )}
              {formSubmitted && invalidYear && (
                 <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter Year Built between 1900 and current year.</small>
                  </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Type of Building</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="typeOfBuilding"
                    onChange={handleInputChange}
                    value={values?.typeOfBuilding}
                  />
                </div>
              </div>
              {formSubmitted && !values?.typeOfBuilding && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">
                    Please enter type of building
                  </small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Description</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="description"
                    onChange={handleInputChange}
                    value={values?.description}
                  />
                </div>
              </div>
              {formSubmitted && !values?.description && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter description</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Occupancy</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="occupancy"
                    onChange={handleInputChange}
                    value={values?.occupancy}
                  />
                </div>
              </div>

              {formSubmitted && !values?.occupancy && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter occupancy</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Category</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <InputText
                    className="vw-inputtext-with-border"
                    autoComplete="off"
                    required={true}
                    name="category"
                    onChange={handleInputChange}
                    value={values?.category}
                  />
                </div>
              </div>

              {formSubmitted && !values?.category && (
                <div className="text-align-left errormsg-margin">
                  <small className="p-error">Please enter category</small>
                </div>
              )}
            </div>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Appreciation</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <NumericFormat
                    className="input-field"
                    style={{ width: "100%" }}
                    thousandSeparator=","
                    autoComplete="off"
                    required={true}
                    name="appreciation"
                    suffix=" %"
                    isAllowed={(val) => {
                      const { floatValue } = val;
                      return (
                        floatValue === undefined ||
                        (floatValue >= minValue && floatValue <= maxValue)
                      );
                    }}
                    decimalScale={2}
                    onBlur={(appreciation) => {
                      handleInputChanges("appreciation", appreciation);
                    }}
                    value={values?.appreciation || 4.5}
                  />
                </div>
              </div>
            </div>
             <label className="mt-4">(Annually)</label>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Rental Increase</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <NumericFormat
                    className="input-field"
                    style={{ width: "100%" }}
                    thousandSeparator=","
                    autoComplete="off"
                    required={true}
                    name="rentalIncrease"
                    suffix=" %"
                    isAllowed={(val) => {
                      const { floatValue } = val;
                      return (
                        floatValue === undefined ||
                        (floatValue >= minValue && floatValue <= maxValue)
                      );
                    }}
                    decimalScale={2}
                    onBlur={(rentalIncrease) => {
                      handleInputChanges("rentalIncrease", rentalIncrease);
                    }}
                    value={values?.rentalIncrease}
                  />
                </div>
              </div>
            </div>
            <label className="mt-4">(Annually)</label>
          </div>
          <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Rent</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                  <NumericFormat
                    className="input-field"
                    style={{ width: "100%" }}
                    thousandSeparator=","
                    autoComplete="off"
                    required={true}
                    name="rent"
                    prefix="$ "
                   
                    decimalScale={2}
                    onBlur={(rent) => {
                      handleInputChangeRent("rent", rent);
                    }}
                    value={values?.rent}
                  />
                </div>
              </div>
            </div>
             <label className="mt-4">(Monthly)</label>
          </div>
           <div className="grid mr-6">
            <div className="col-12 md:col-12 lg:col-4 mt-3">
              <label>Rental Start Year</label>
            </div>
            <div className="col-12 md:col-12 lg:col-6">
              <div className="field">
                <div className="p-inputgroup">
                 <InputNumber
                        className="vw-inputnumber-with-border"
                        useGrouping={false}
                        maxFractionDigits={0}
                        placeholder="YYYY"
                        name="rentStartDate"
                        onValueChange={handleYearChange}
                        value={values?.rentStartDate}
                      />
                </div>
              </div>
              <div className="text-align-left">
                {invalidRentYear && values.rent && values.rent > 0 && (
                  <small className="p-error">
                    {values.rentStartDate === null || values.rentStartDate === undefined || values.rentStartDate === ''
                      ? 'Rental start year is required when rental income is provided'
                      : 'Rental start year must be after purchase year'}
                  </small>
                )}
              </div>
            </div>
          </div>
          {renderFooter()}
        </div>
      </div>
    </Panel>
  );
};

export default PropertyInformation;
